module.exports = __webpack_public_path__ + "teqbahn-assets/media/Services2.ee370ac4.png";